export default [
  {
    title: 'breadcrumb.report',
    header: 'breadcrumb.report',
    icon: '',
    children: [
      {
        title: 'breadcrumb.cockBalanceReport',
        route: 'cock-balance-report',
        icon: '',
        resource: 'balance-report',
        action: 'read',
      },
      {
        title: 'breadcrumb.baccaratBalanceReport',
        route: 'baccarat-balance-report',
        icon: '',
        resource: 'baccarat-balance-report',
        action: 'read',
      },
    ],
  },
]
